module.exports = "/fonts/line-awesome.svg?131b7f1e91a652791f08f5ccfe702645";